import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

const SITE_NAME = 'Verse'
const DEFAULT_TITLE = 'Verse — Write Your World'
const DEFAULT_DESC = 'Verse is a social writing platform where you can publish stories, fanfiction, quizzes, and connect with a community of readers and writers.'
const DEFAULT_IMAGE = '/icon-512.png'
const BASE_URL = 'https://versesite.net'

export default function SEO({ title, description, image, type = 'website', noindex = false, jsonLd }) {
  const { pathname } = useLocation()
  const fullTitle = title ? `${title} — ${SITE_NAME}` : DEFAULT_TITLE
  const desc = description || DEFAULT_DESC
  const img = image || DEFAULT_IMAGE
  const url = `${BASE_URL}${pathname}`
  const absoluteImg = img.startsWith('http') ? img : `${BASE_URL}${img}`

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta name="creator" content="ZAH" />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={absoluteImg} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={absoluteImg} />

      {/* JSON-LD Structured Data */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd).replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/&/g, '\\u0026').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029')}</script>
      )}
    </Helmet>
  )
}
